import { render, staticRenderFns } from "./InviteList.vue?vue&type=template&id=2e3ba6cb&scoped=true&"
import script from "./InviteList.vue?vue&type=script&lang=js&"
export * from "./InviteList.vue?vue&type=script&lang=js&"
import style0 from "./InviteList.vue?vue&type=style&index=0&id=2e3ba6cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3ba6cb",
  null
  
)

export default component.exports